import {
  AISMLLMAPI,
  // BPIAM_API,
  KNOWLEDGE,
  KNOWLEDGE_API,
  MARKETING_API,
  OSS_API,
  // WPSKnowledgeBaseAPI,
  WPSLoginAPI,
} from '@/constants/API';
import { request } from '@umijs/max';

// 保存行业人设
export async function assistantPersonality(params: any) {
  return request(`${MARKETING_API}/product/assistant/industryPersonality`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 新增编辑品牌
export async function brandPsert(params: any) {
  return request(`${MARKETING_API}/brand/upsert`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 获取品牌列表
export async function serBrandList({
  assistantId,
  state = '',
}: {
  assistantId: string | undefined;
  state?: string | number;
}) {
  return request(`${MARKETING_API}/brand/list/${assistantId}?state=${state}`, {
    method: 'get',
  });
}

// 品牌排序
export async function serBrandRank(params: any) {
  return request(`${MARKETING_API}/brand/rank`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 物料列表
export async function serMaterialList(params: any) {
  return request(`${MARKETING_API}/material/list`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 新增或更新物料
export async function sermaterialUpsert(params: any) {
  return request(`${MARKETING_API}/material/upsert`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 物料更新排序
export async function serMaterialRank(params: any) {
  return request(`${MARKETING_API}/material/rank`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 物料删除
export async function serMaterial(params: any) {
  return request(`${MARKETING_API}/material/delete`, {
    method: 'DELETE',
    data: {
      ...params,
    },
  });
}

// 物料上下架
export async function serMaterialState(params: any) {
  return request(`${MARKETING_API}/material/state`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 产品删除
export async function serBrandProductsDelete(params: any) {
  return request(`${MARKETING_API}/brand/products/delete`, {
    method: 'DELETE',
    data: {
      ...params,
    },
  });
}

// 产品上下架
export async function serbrandProductsState(params: any) {
  return request(`${MARKETING_API}/brand/products/state`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 产品统计
export async function serbrandProductsStatistics(brandId: any) {
  return request(`${MARKETING_API}/brand/products/statistics/${brandId}`);
}

// 品牌删除
export async function serBrandDelete(id: any) {
  return request(`${MARKETING_API}/brand/${id}`, {
    method: 'DELETE',
  });
}

// 品牌上下架
export async function serBrandState(params: any) {
  return request(`${MARKETING_API}/brand/state`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 产品列表
export async function serBrandProductsList(params: any) {
  return request(`${MARKETING_API}/brand/products/list`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 产品更新排序
export async function serbrandProductsRank(params: any) {
  return request(`${MARKETING_API}/brand/products/rank`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 新增或更新产品
export async function serbrandProductsUpsert(params: any) {
  return request(`${MARKETING_API}/brand/products/upsert`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 查询权限
export async function serAssistantList(params: any) {
  return request(`${MARKETING_API}/user/assistant/list`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 生成方案
export async function serBuildAScenario(params: any) {
  return request(`${MARKETING_API}/scheme/parameter/buildAScenario`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}

// 修改行业人设
export async function serUpdateIndustryPersonas(params: any) {
  return request(
    `${MARKETING_API}/assistant/placement/updateIndustryPersonas`,
    {
      method: 'POST',
      data: {
        ...params,
        appId: process.env.appId,
      },
    },
  );
}

// 编辑用户品牌
export async function serEditUserBrand(params: any) {
  return request(`${MARKETING_API}/user/assistant/editUserBrand`, {
    method: 'PUT',
    data: {
      ...params,
    },
  });
}

// 删除助手用户
export async function serUserAssistant(params: any) {
  return request(`${MARKETING_API}/wps/user/assistant/deleteWpsUser`, {
    method: 'POST',
    data: params,
  });
}

// 查询用户品牌
export async function queryUserBrand(params: any) {
  return request(`${MARKETING_API}/user/assistant/queryUserBrand`, {
    method: 'GET',
    params: {
      ...params,
    },
  });
}

// 编辑助手用户的角色
export async function userAssistantEdit(params: any) {
  return request(`${MARKETING_API}/user/assistant/edit`, {
    method: 'PUT',
    data: {
      ...params,
    },
  });
}

// 获取知识库列表
export async function queryKnowledgeForPage(data: any) {
  const { id = '' } = data;
  return request(`${MARKETING_API}/folder/${id}`);
}

// 根据id获取知识库详情
export async function knowledgeInfoById(params: any) {
  return request(`${KNOWLEDGE_API}/api/knowledge/queryKnowledgeForPage`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 获取人员列表
export async function fetchTenantUsers() {
  return request(`${WPSLoginAPI}/external/user/list`);
}

export async function fetchTeamDescription() {
  return request(`${WPSLoginAPI}//app/secrets/get_permission_description`);
}

// 新增助手用户
export async function userAssistantAdd(params: any) {
  return request(`${MARKETING_API}/wps/user/assistant/addWpsUser`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 继续生成
export async function schemeContinueImage(params: any) {
  return request(`${MARKETING_API}/scheme/image/continueImage`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}

// 删除方案图片
export async function schemeDeleteImage(ids: any) {
  return request(`${MARKETING_API}/scheme/image/deleteImage/${ids}`);
}

// 导出品牌
export async function productsExport(assistantId: any) {
  return request(`${MARKETING_API}/brand/products/export/${assistantId}`, {
    responseType: 'blob',
    getResponse: true,
  }).then((response) => {
    // 创建一个Blob对象
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel',
    });
    const disposition = decodeURIComponent(
      response.headers['content-disposition'],
    );
    const matchArray = disposition.split('filename=')[1];
    const filename = matchArray;
    // 创建一个临时的下载链接
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    // 将下载链接添加到文档中并触发点击事件
    document.body.appendChild(link);
    link.click();

    // 移除下载链接并释放URL对象
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  });
}

// 获取生成方案的数据
export async function brandSchemeData(id: any) {
  return request(`${MARKETING_API}/brand/scheme_data/${id}`);
}

// 获取生成风格
export async function brandStyleData() {
  return request(`${MARKETING_API}/scheme/parameter/getStyleTagList`);
}

// 批量导入品牌
export async function productsImport({ file, assistantId }: any) {
  return request(`${MARKETING_API}/brand/products/import/${assistantId}`, {
    method: 'POST',
    // headers: {
    //   'Content-Type': 'multipart/form-data',
    // },
    data: file,
  });
}

/* 知识库-新接口 */
export function queryKnowledgeBaseForBrain(data: any) {
  return request(KNOWLEDGE + 'folder/queryKnowledgeBaseForBrain', {
    method: 'POST',
    data,
  });
}

//全部知识库
export function queryKnowledgeBaseForAll(data: any) {
  return request(KNOWLEDGE + 'folder/queryKnowledgeBaseForBrain', {
    method: 'POST',
    data,
  });
}

// 团队知识库
export function queryTeamKnowledge(data: any) {
  return request(KNOWLEDGE + 'folder/queryTeamKnowledge', {
    method: 'POST',
    data,
  });
}

// 个人知识库
export function queryIndividual(data: any) {
  return request(KNOWLEDGE + 'folder/queryIndividual', {
    method: 'POST',
    data,
  });
}

// 公共知识库
export function queryPublicKnowledge(data: any) {
  return request(KNOWLEDGE + 'folder/queryPublicKnowledge', {
    method: 'POST',
    data,
  });
}

// 知识上传 oss 接口
export function uploadArrayFile(data: any) {
  return request(OSS_API + 'uploadArrayFile', {
    method: 'POST',
    data,
  });
}

// 知识上传
export function uploadKnowledgeBySave(data: any) {
  return request(KNOWLEDGE + 'knowledge/uploadKnowledgeBySave', {
    method: 'POST',
    data,
  });
}

// 知识上传
export function folderDetails(id: any) {
  return request(KNOWLEDGE + 'folder/folderDetails/' + id, {
    method: 'GET',
  });
}
// 知识上传 - python
export function create_index(data: any) {
  return request(AISMLLMAPI + 'v2/create_index', {
    method: 'POST',
    data,
  });
}

// 删除知识点 - python
export function delete_points(data: any) {
  return request(AISMLLMAPI + 'delete_index', {
    method: 'POST',
    data,
  });
}

// 删除知识点
export function delKnowledgeOrDisable(data: any) {
  return request(KNOWLEDGE + 'knowledge/delKnowledgeOrDisable', {
    method: 'POST',
    data,
  });
}

// 恢复默认知识库
export async function recoverFolder(id: any) {
  return request(`${MARKETING_API}/folder/recover_folder/${id}`, {
    method: 'PUT',
  });
}

// 生成知识库图片
export function generateAnImage(data: any) {
  return request(MARKETING_API + '/scheme/image/generateAnImage', {
    method: 'POST',
    data: {
      ...data,
      appId: process.env.appId,
    },
  });
}

// 修改方案状态
export function determineWhetherThePlanIsSuccessful(data: any) {
  return request(
    MARKETING_API +
      `/scheme/parameter/determineWhetherThePlanIsSuccessful/${data.id}`,
    {
      method: 'POST',
      data: data.list,
    },
  );
}
